import { DataUtilities } from "../../DataUtilities";
import { IDataDefinition } from "../Definitions/IDataDefinition";
import { DataDefinition } from "../DataDefinition";
import { DataStructureDifferences } from "./DataStructureDifferences";

export class DeleteFieldToDataStructure implements DataStructureDifferences {
    field: IDataDefinition;
    path: string;

    constructor(field: IDataDefinition, path: string) {
        this.field = field;
        this.path = path;
    }

    getMessage(): string {
        const pieces: string[] = this.path.split(".");
        const path = pieces.length > 1 ? pieces.join(" -> ") : "root";
        return `Delete Field ${this.field.name} from ${path}`;
    }

    apply(def: DataDefinition) {
        DataUtilities.removeFieldByPath(def, this.path);
    }
}
